import { createBusinessComponent } from '../utils/create';
import { getCookie } from '../utils/cookies';
import { getChannelByTheme } from '@tujia/fe-css/lib/jsUtil/themeHelper';
import { getPlatform } from '@tujia/fe-lib-common/lib/tj-utils/platform';
var pwaBetaHost = (window.location.host.match(/\d/) ? "https://pwa" + window.location.host.match(/\d/)[0] + ".beta.tujia.com" : 'https://pwa.fvt.tujia.com') + " ";
var PWAHOST = {
  'nm': 'http://nm.fvt.tujia.com:8080',
  't1': 'https://pwa1.fvt.tujia.com',
  't2': 'https://pwa2.fvt.tujia.com',
  'fvt': 'https://pwa.fvt.tujia.com',
  'beta': pwaBetaHost,
  'online': 'https://pwa.tujia.com'
};
var MHOST = {
  'nm': 'http://nm.fvt.tujia.com:8080',
  't1': 'https://m1.fvt.tujia.com',
  't2': 'https://m2.fvt.tujia.com',
  'fvt': 'https://m.fvt.tujia.com',
  'beta': "https://" + window.location.host,
  'online': 'https://m.tujia.com'
};
var PASSPORTHOST = {
  'nm': 'http://passport.dev.tujia.com',
  't1': 'https://passport1.fvt.tujia.com',
  't2': 'https://passport2.fvt.tujia.com',
  'fvt': 'https://passport.fvt.tujia.com',
  'online': 'https://passport.tujia.com'
};
/** tabPosition:  index ,favor,order,im,link*/

export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [_c('div', {
      staticStyle: {
        "height": "55px"
      }
    }), _c('div', {
      staticClass: "tab-wrap"
    }, [_vm._l(_vm.tabList, function (i, idx) {
      return [!_vm.hideTabName || _vm.hideTabName.indexOf(i.flag) === -1 ? _c('div', {
        key: idx,
        staticClass: "tab-footer ",
        class: _vm.tabPosition === i.flag ? 'active' : '',
        attrs: {
          "data-fas-event-name": "FAS_BOTTOM_BAR_BUTTON_CLICK",
          "data-fas-buttom-val": i.tx
        },
        on: {
          "click": function click($event) {
            _vm.tabChange(idx);
          }
        }
      }, [_c('div', {
        staticClass: "img",
        style: {
          background: "url(" + (_vm.tabPosition === i.flag ? _vm.getBackgroundUrl(i) : i.unImgUrl) + ") no-repeat center center"
        }
      }), _c('p', [_vm._v(_vm._s(i.tx))])]) : _vm._e()];
    })], 2), _c('div', {
      staticClass: "fit-x"
    })]);
  },
  name: 'tab-bar-bottom',
  props: {
    isLogin: Boolean,
    tabPosition: String,
    hideTabName: {
      type: String,
      default: ''
    },
    gotoLogin: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      // tab list
      tabList: [{
        tx: '首页',
        flag: 'index',
        eImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-index-e.png',
        cImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-index-c.png',
        mImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-index-m.png',
        imgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-index-p.png',
        unImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-unindex.png',
        navigationUrl: '/'
      }, {
        tx: '收藏',
        flag: 'favor',
        eImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-favor-e.png',
        cImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-favor-c.png',
        mImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-favor-m.png',
        imgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-favor-p.png',
        unImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-unfavor.png',
        navigationUrl: '/tbnb/favorite'
      }, {
        tx: '订单',
        flag: 'order',
        eImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-order-e.png',
        cImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-order-c.png',
        mImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-order-m.png',
        imgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-order-p.png',
        unImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-unorder.png',
        navigationUrl: '/tbnb/order/list'
      }, {
        tx: '消息',
        flag: 'im',
        eImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-IM-e.png',
        cImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-IM-c.png',
        mImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-IM-m.png',
        imgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-IM-p.png',
        unImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-unIM.png',
        navigationUrl: "/h5/mob/messagecenter/index?mref=h5"
      }, {
        tx: '联系客服',
        flag: 'link',
        eImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-link.png',
        cImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-link.png',
        imgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-link.png',
        unImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-link.png',
        navigationUrl: 'tel:4006115718'
      }],
      // 我的 tab
      myTab: {
        tx: '我的',
        flag: 'my',
        eImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-my-p.png',
        cImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-my-p.png',
        mImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-my-p.png',
        imgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-my-p.png',
        unImgUrl: 'https://pic.tujia.com/upload/festatic/publicImages/icon-tab-unmy.png',
        navigationUrl: '/my'
      },
      // 环境
      env: '',
      // 站点
      site: '',
      PWAHOST: PWAHOST,
      MHOST: MHOST,
      // 当前站点的host
      curHost: window.location.host,
      tabPositionArr: ['index']
    };
  },
  created: function created() {
    this._envJudge();

    if (!this.isJdChannel()) {
      this.tabList = this.tabList.slice(0, this.tabList.length - 1);

      if (getChannelByTheme() === 'qunar') {
        this.tabList = this.tabList.slice(0, this.tabList.length - 1);
      }

      if (getPlatform().isKuaiShouMpEnv) {
        this.tabList.push(this.myTab);
      }
    }

    this._siteJudge();
  },
  methods: {
    /**
     * jd 渠道
     */
    isJdChannel: function isJdChannel() {
      return getCookie().tj_channel_id === 'jdbnb';
    },

    /**
     * tab 切换
     */
    tabChange: function tabChange(idx) {
      var url = this.tabList[idx].navigationUrl;
      var flag = this.tabList[idx].flag;

      if (flag !== 'index') {
        if (!this.isLogin) {
          if (this.gotoLogin) {
            this.gotoLogin();
          } else {
            window.location.href = PASSPORTHOST[this.env] + "/H5Site/LoginPage/?srcurl=" + encodeURIComponent(window.location.href) + "&srcLocalSite=goSite";
          }

          return;
        }
      }

      if (this.isJdChannel()) {
        if (flag === 'order') {
          window.location.href = '//hotel.m.jd.com/orderlist';
          return;
        }

        if (flag === 'link') {
          window.location.href = url;
          return;
        }
      }

      if (flag === 'im' && this.site === 'pwa') {
        this.$router.replace({
          path: 'messagecenter/index',
          query: {
            mref: 'h5'
          }
        });
      } else if (this.site === 'pwa') {
        window.location.href = this.MHOST[this.env] + url;
      } else if (flag === 'im' && this.site === 'mob') {
        window.location.href = this.PWAHOST[this.env] + url;
      } else if (this.site === 'mob') {
        this.$router.replace({
          path: url
        });
      }
    },

    /**
     * 环境判断
     */
    _envJudge: function _envJudge() {
      if (this.curHost.indexOf('.nm') > -1) {
        this.env = 'nm';
      } else if (/^\D*\.fvt/.test(this.curHost)) {
        this.env = 'fvt';
      } else if (this.curHost.indexOf('1.fvt') > -1) {
        this.env = 't1';
      } else if (this.curHost.indexOf('2.fvt') > -1) {
        this.env = 't2';
      } else if (this.curHost.indexOf('.beta') > -1) {
        this.env = 'beta';
      } else {
        this.env = 'online';
      }
    },

    /**
     * 站点判断
     */
    _siteJudge: function _siteJudge() {
      if (/pwa/.test(this.curHost)) {
        this.site = 'pwa';
      } else {
        this.site = 'mob';
      }
    },

    /**
     * 站点判断
     * @param item icon索引
     */
    getBackgroundUrl: function getBackgroundUrl(item) {
      var channel = getChannelByTheme();

      if (channel === 'elong') {
        return item.eImgUrl;
      } else if (channel === 'ctrip') {
        return item.cImgUrl;
      } else if (channel === 'mayi') {
        return item.mImgUrl;
      } else {
        return item.imgUrl;
      }
    }
  }
});